

export function String10E(decimals: number): string {
    return `1${"0".repeat(decimals)}`;
}